<template>
	<div>
		<b-breadcrumb>Users</b-breadcrumb>
		<b-input v-model="q" placeholder="Search..." @input="loadUsers()" class="mb-2"></b-input>
		<b-table small striped hover :items="users" :busy="loading>0" :fields="['id', 'username','restreaming_service','widgets','billing',{ label: '', key: 'actions', thClass: 'text-right', tdClass: 'text-right'}]">
			<template #head(actions)="">
				<b-button @click="$refs.editModal.show()" variant="success" size="sm" v-b-tooltip.hover.left.v-success title="Add a user"><b-icon icon="plus"></b-icon></b-button>
			</template>
			<template #cell(username)="data">
				{{data.item.username}}<br />
				<small :class="{'text-danger':!data.item.email_confirmed}">{{data.item.email}}<span v-if="!data.item.email_confirmed"> (unconfirmed)</span></small>
			</template>
			<template #cell(restreaming_service)="data">
				<router-link v-if="data.item.restreaming_service_id" :to="{ name: 'Service', params: { id: data.item.restreaming_service_id } }">{{data.item.restreaming_service_name}}</router-link>
			</template>
			<template #cell(widgets)="data">
				<a :href="`/widget/chat.html?hash=${data.item.widget_hash}`" target="_blank" title="Open chat widget">Chat</a> &bull;
				<a :href="`/widget/viewerCount.html?hash=${data.item.widget_hash}`" target="_blank" title="Open viewer count widget">VC</a> &bull;
				<a :href="`/widget/wordCloud.html?hash=${data.item.widget_hash}`" target="_blank" title="Open word cloud widget">WC</a> &bull;
				<a :href="`/widget/highlightedMessage.html?hash=${data.item.widget_hash}`" target="_blank" title="Open highlighted message widget">HM</a>
			</template>
			<template #cell(billing)="data">
				{{data.item.subscription_status}} {{data.item.plan}} {{data.item.period}}
			</template>
			<template #cell(actions)="data">
				<b-dropdown right size="sm" variant="default">
					<b-dropdown-item @click="$refs.editModal.show(data.item.id)"><b-icon icon="pencil-fill"></b-icon> Edit user</b-dropdown-item>
					<b-dropdown-item @click="$refs.deleteModal.show(data.item.id)" variant="danger"><b-icon icon="trash"></b-icon> Delete user</b-dropdown-item>
					<b-dropdown-divider></b-dropdown-divider>
					<b-dropdown-item @click="grantGratuity(data.item.id, 'regular')">Grant Regular gratuity</b-dropdown-item>
					<b-dropdown-item @click="grantGratuity(data.item.id, 'pro')">Grant Pro gratuity</b-dropdown-item>
					<b-dropdown-item @click="revokeGratuity(data.item.id)">Revoke gratuity</b-dropdown-item>
					<b-dropdown-divider></b-dropdown-divider>
					<b-dropdown-item @click="syncRestreaming(data.item.id)">Recreate ingest and egress</b-dropdown-item>
					<b-dropdown-item @click="loginAsUser(data.item.id)">Login as user</b-dropdown-item>
				</b-dropdown>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<user-edit-modal ref="editModal" @saved="loadUsers"></user-edit-modal>
		<user-delete-modal ref="deleteModal" @deleted="loadUsers"></user-delete-modal>
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';
import UserEditModal from '@/components/User/Modal/Edit.vue';
import UserDeleteModal from '@/components/User/Modal/Delete.vue';

export default {
	name: 'Users',
	components: {
		Pager,
		UserEditModal,
		UserDeleteModal,
	},
	data() { return {
		users: [],
		error: null,
		loading: 0,
		total: 0,
		skip: 0,
		perPage: 10,
		q: undefined,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip||0)||0;
		this.perPage = parseInt(this.$route.query.perPage||10)||10;
		this.loadUsers();
	},
	watch: {
		'$route': 'loadUsers',
		'q': 'loadUsers',
	},
	methods: {
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage }});
		},
		loadUsers() {
			this.loading++;
			this.error = null;
			this.$api.get('users', { q: this.q||'', limit: this.perPage, skip: this.skip }).then(users => {
				this.users = users.results;
				this.total = users.total;
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
		async syncRestreaming(userId) {
			try {
				await this.$api.post(`syncRestreaming/${userId}`);
				this.$bvToast.toast('Synchronized restreaming', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
			} catch(e) {
				this.$bvToast.toast(e.toString(), {
					title: 'Error',
					variant: 'danger',
					solid: true
				});
			}
		},
		async loginAsUser(userId) {
			const { token } = await this.$api.post(`auth/${encodeURIComponent(userId)}`);
			this.$auth.pushToken(token);
			this.$router.push('/');
		},
		async grantGratuity(userId, plan) {
			try {
				await this.$api.post(`user/${userId}/gratuity`, { plan });
				this.$bvToast.toast(`Granted ${plan} gratuity`, { title: 'Success', variant: 'success', solid: true });
				this.loadUsers();
			} catch(e) {
				this.$bvToast.toast(e.error || e.toString(), { title: 'Error', variant: 'danger', solid: true });
			}
		},
		async revokeGratuity(userId) {
			try {
				await this.$api.post(`user/${userId}/gratuity`, {});
				this.$bvToast.toast('Gratuity revoked', { title: 'Success', variant: 'success', solid: true });
				this.loadUsers();
			} catch(e) {
				this.$bvToast.toast(e.error || e.toString(), { title: 'Error', variant: 'danger', solid: true });
			}
		},
	},
};
</script>
